import { getAllUserInterestsRequest, getPendingStudentsRequest } from "../requests/users";

const getInterests = async (userId) => {
  const res = await getAllUserInterestsRequest({ userId: userId });

  // New Students panel expects the following attributes:
  return (
    res.data.map((interest) => ({
      id: interest.id,
      student_id: interest.student.id,
      days_of_inactivity: interest.days_of_inactivity,
      address: interest.address,
      address_2: interest.address_2,
      city: interest.city,
      state: interest.state,
      zip_code: interest.zip_code,
      country: interest.country,
      first_name: interest.student.first_name,
      last_name: interest.student.last_name,
    }))
  );
};

const getPendingStudents = async (userId) => {
  const res = await getPendingStudentsRequest({ userId: userId });

  // New Students panel expects the following attributes:
  return (
    res.data.map((student) => ({
      id: student.id,
      student_id: student.id,
      days_of_inactivity: student.days_of_inactivity,
      address: student.address,
      address_2: student.address_2,
      city: student.city,
      state: student.state,
      zip_code: student.zip_code,
      first_name: student.first_name,
      last_name: student.last_name,
    }))
  );
};

export const getNewStudents = ({ userData }) => {
  // The same user can be a Head School Admin and has other roles as well.
  // We'll choose one condition for now: Head School Admin or not, so New Students panel will show either
  // Interests or Students. Currently, New Students component won't work by mixing both types.
  const hasHeadAdminRole = userData?.head_school_admin_for_schools?.length > 0;

  return hasHeadAdminRole ? getInterests(userData.id) : getPendingStudents(userData.id);
}
